import { useLayoutEffect, useState } from "react";

const useWindowSize = () => {
  const [size, setSize] = useState({
    width: window.innerWidth || 0,
    height: window.innerHeight || 0,
  });

  useLayoutEffect(() => {
    const calcSize = () =>
      setSize({ width: window.innerWidth, height: window.innerHeight });
    calcSize();
    window.addEventListener("resize", calcSize);
    return () => window.removeEventListener("resize", calcSize);
  }, []);

  return size;
};

export default useWindowSize;
